var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"page p4"},[_c('router-view',{attrs:{"pool":_vm.pool},on:{"submit":function($event){_vm.submit = true},"graph":_vm.changeGraph},model:{value:(_vm.pool),callback:function ($$v) {_vm.pool=$$v},expression:"pool"}}),_vm._v(" "),(_vm.submit)?_c('deploy',{attrs:{"pool":_vm.pool}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c09dda8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Start/Index.vue
// module id = null
// module chunks = 